import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "destroyField", "idField" ]

  remove(event) {
    event.preventDefault()

    if (this.hasIdFieldTarget && this.idFieldTarget.value && this.hasDestroyFieldTarget) {
      this.destroyFieldTarget.value = "1"
      this.destroyFieldTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.destroyFieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
      this.element.classList.add("hidden")
      this.dispatch("removed", { bubbles: true })
    } else {
      this.element.remove()
    }
  }
}
